export const getAgentName = agent => {
	if (!agent) return null;
	if (agent.displayName) return agent.displayName;
	if (agent.email) {
		const emailName = agent.email.split('@')[0].split('.');
		const firstName = emailName[0];
		const lastName = emailName[1];
		return [lastName?.toUpperCase(), firstName?.toUpperCase()].filter(Boolean).join(' ');
	}
	return null;
};
